module.exports = __webpack_public_path__ + "static/media/_ivory-coast.1181db19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_ivory-coast.svg
// module id = 2330
// module chunks = 7